import React from "react";
import './FlexiFooter.css'

const FelxiFooter = () => {
  return (
    <div
      className="flexi-footer-main"
    >
      <h1>
        Designed and Developed With
        <span> 💚 </span>
        By <span><br></br>Rajat Vaidhya</span>
      </h1>
    </div>
  );
};

export default FelxiFooter;
